import { z } from 'zod';
import { BoardModelSchema } from './BoardCatalog.js';
import { SensorTypeSchema } from './Sensor.js';

export const SensorOutputKindSchema = z.enum([
  'analog_v',
  'analog_ma',
  'digital_pulse',
  'i2c',
  'spi',
  'modbus',
]);

export const SensorModelSchema = z.object({
  id: z.string().min(1),
  kind: z.literal('sensor'),
  display_name: z.string().min(1),
  vendor: z.string().min(1),
  sensor_type: SensorTypeSchema,
  output_kind: SensorOutputKindSchema,
  default_calibration: z.object({
    scaling_factor: z.number(),
    scaling_offset: z.number(),
    units: z.string().nullable(),
  }),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const HardwareModelSchema = z.discriminatedUnion('kind', [
  BoardModelSchema,
  SensorModelSchema,
]);

export type ParsedHardwareModel = z.infer<typeof HardwareModelSchema>;
export type ParsedSensorModel = z.infer<typeof SensorModelSchema>;
export type ParsedSensorOutputKind = z.infer<typeof SensorOutputKindSchema>;
